<template>
  <v-dialog v-model="visible" max-width="700px">
    <v-card style="overflow-y: hidden">
      <v-card-title>{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="[
                  { text: 'Cuenta de Gastos', value: 'Gastos' },
                  { text: 'Cuenta de Recursos', value: 'Recursos' },
                  { text: 'Cuenta Contable de Gastos', value: 'Contable Gastos' },
                  { text: 'Cuenta Contable de Recursos', value: 'Contable Recursos' },
                ]"
                label="Tipo de Cuenta"
                item-text="text"
                item-value="value"
                v-model="form.tipo_partida"
                outlined
                dense
                hide-details
                @change="onHandleChangeTipoPartida" />
            </v-col>

            <v-col cols="12">
              <vue-select
                v-model="form.grupo_id"
                class="style-chooser"
                placeholder="Grupo"
                :options="gruposConSubgrupos"
                label="label"
                :selectable="(option) => !!option.grupo_id"
                :reduce="(option) => option.id"
                :disabled="form.acepta_registro == 0">
                <template v-slot:option="option">
                  <span v-html="option.text"></span>
                </template>
              </vue-select>

              <small v-for="error in errores.grupo_id" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <vue-select
                v-model="form.padre_id"
                class="style-chooser"
                placeholder="Cuenta padre"
                label="nombre"
                :key="form.padre_id"
                :reduce="(op) => op.id"
                :options="partidasItems"
                :disabled="!seMuestranCamposPresupuestarios">
                <template v-slot:option="option">
                  <span v-html="option.descripcion_tabulada"></span>
                </template>
              </vue-select>
              <small v-for="error in errores.padre_id" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <!-- <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <vue-select
                v-model="form.cuenta_contable_id"
                class="style-chooser"
                placeholder="Cuenta contable"
                label="nombre"
                :key="form.cuenta_contable_id"
                :reduce="(op) => op.id"
                :options="clasificadoresContables"
                :disabled="!seMuestranCamposPresupuestarios">
                >
              </vue-select>

              <small v-for="error in errores.cuenta_contable_id" :key="error" class="text-danger">{{ error }}</small>
            </v-col> -->

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <v-text-field
                label="Codigo"
                v-model="form.codigo"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.codigo" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <v-text-field
                label="Nombre"
                v-model="form.nombre"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <v-text-field
                label="Descripción"
                v-model="form.descripcion"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.descripcion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <v-select
                :items="[
                  { text: 'Si', value: true },
                  { text: 'No', value: false },
                ]"
                label="Acepta registro"
                item-text="text"
                item-value="value"
                v-model="form.acepta_registro"
                outlined
                dense
                hide-details />

              <small v-for="error in errores.acepta_registro" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" class="mb-3" style="padding-bottom: 0px !important">
              <v-select
                :items="[
                  { text: 'Banco', value: 'Banco' },
                  { text: 'Cuentas a cobrar', value: 'Cuentas a cobrar' },
                  { text: 'Otros activos corrientes', value: 'Otros activos corrientes' },
                  { text: 'Activo fijo', value: 'Activo fijo' },
                  { text: 'Otro activo', value: 'Otro activo' },
                  { text: 'Otros pasivos corrientes', value: 'Otros pasivos corrientes' },
                  { text: 'Cuentas a pagar', value: 'Cuentas a pagar' },
                  { text: 'Pasivo a largo plazo', value: 'Pasivo a largo plazo' },
                  { text: 'Tarjeta de crédito', value: 'Tarjeta de crédito' },
                  { text: 'Patrimonio', value: 'Patrimonio' },
                  { text: 'Ingresos', value: 'Ingresos' },
                  { text: 'Otros ingresos', value: 'Otros ingresos' },
                  { text: 'Costo de los artículos vendidos', value: 'Costo de los artículos vendidos' },
                  { text: 'Gasto', value: 'Gasto' },
                ]"
                label="Tipo de Cuenta (ORACLE)"
                v-model="form.tipo_oracle"
                :disabled="!seMuestranCamposPresupuestarios"
                outlined
                dense
                hide-details />

              <small v-for="error in errores.tipo_oracle" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000">
      Complete los campos
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ModalFormMixin from '../mixins/modal-form-mixin.js';
import ClasificadorServices from '../services/clasificador.js';
import { formatearErrores, formatearGrupos, formatearPartidas } from '../utils';
import GruposServices from '../services/grupo';

export default {
  name: 'ModalFormPartida',
  mixins: [ModalFormMixin],
  props: {},
  data() {
    return {
      snackbar: false,
      partidasItems: [],
      clasificadoresContables: [],
      gruposConSubgrupos: [],
    };
  },
  watch: {
    'form.padre_id': function () {
      this.errores.padre_id = [];
    },
    'form.codigo': function () {
      this.errores.codigo = [];
    },
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.descripcion': function () {
      this.errores.descripcion = [];
    },
    'form.cuenta_contable_id': function () {
      this.errores.cuenta_contable_id = [];
    },
    'form.acepta_registro': function (val) {
      this.errores.acepta_registro = [];

      if (!val) {
        this.form.grupo_id = null;
      }
    },
    'form.tipo_oracle': function () {
      this.errores.tipo_oracle = [];
    },
    'form.grupo_id': function () {
      this.errores.grupo_id = [];
    },
  },
  computed: {
    seMuestranCamposPresupuestarios() {
      return this.form.tipo_partida == 'Gastos' || this.form.tipo_partida == 'Recursos';
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: '',
        descripcion: '',
        nombre: '',
        tipo_partida: null,
        padre_id: null,
        cuenta_contable_id: null,
        acepta_registro: null,
        tipo_oracle: null,
        grupo_id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        descripcion: data.descripcion,
        nombre: data.nombre,
        tipo_partida: data.tipo_partida,
        padre_id: data.padre_id,
        cuenta_contable_id: data.cuenta_contable_id,
        acepta_registro: data.acepta_registro,
        tipo_oracle: data.tipo_oracle,
        grupo_id: data.grupo_id,
      };
    },
    abrir(accion, data = []) {
      this.obtenerGruposConSubgrupos();
      this.abrirMixin(accion, data);
    },
    onHandleChangeTipoPartida() {
      this.form.padre_id = null;
      this.form.cuenta_contable_id = null;
      this.form.acepta_registro = null;
      this.form.tipo_oracle = null;
      this.obtenerClasificadoresContables();
      this.getPartidas();
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await ClasificadorServices.update(this.form.id, this.form);
        } else {
          response = await ClasificadorServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async getPartidas() {
      if (!this.form.tipo_partida) {
        return;
      }

      this.partidasItems = [];

      try {
        const response = await ClasificadorServices.getTipoPartida(this.form.tipo_partida);
        const partidas = response.data.datos;
        const partidasAplanadas = [];
        formatearPartidas(partidas, partidasAplanadas, '', 0);

        this.partidasItems = partidasAplanadas;
      } catch (err) {
        window.console.log(err);
      }
    },
    async obtenerClasificadoresContables() {
      if (!this.form.tipo_partida) {
        return;
      }

      this.clasificadoresContables = [];

      try {
        const params = {
          tipo_partida: `Contable ${this.form.tipo_partida}`,
        };
        const response = await ClasificadorServices.get({ params });
        this.clasificadoresContables = response.data?.datos.map((clasificadorContable) => ({
          id: clasificadorContable.id,
          nombre: `${clasificadorContable.codigo} ${clasificadorContable.nombre}`,
        }));
      } catch (err) {
        window.console.log(err);
      }
    },
    async obtenerGruposConSubgrupos() {
      try {
        const { data } = await GruposServices.getConSubgrupos();
        const grupos = data.datos;
        const gruposConSubgruposAplanados = [];

        formatearGrupos(grupos, gruposConSubgruposAplanados, '', 0);

        this.gruposConSubgrupos = gruposConSubgruposAplanados;
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .container,
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}

::v-deep .container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
}
</style>

<style>
.v-select ul[role='listbox'] {
  max-height: 260px;
  height: 260px;
}
</style>